import { BASE_URL } from '../components/AppConfig';
import { handleDynamicRequest, handleDynamicRequestHeader, handleDynamicRequestHeaderMulter } from '../components/DyanamicRequest';

// Create a new meme
export const createMeme = async (memeData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    formData.append('name', memeData.name);
    formData.append('kind', memeData.kind);
    formData.append('category', memeData.category);
    if (memeData.context) formData.append('context', memeData.context);
    if (memeData.emotion) formData.append('emotion', memeData.emotion);
    if (memeData.keywords) formData.append('keywords', JSON.stringify(memeData.keywords));
    if (memeData.image) formData.append('image', memeData.image);

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'POST',
      `${BASE_URL}/admin/memes`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to create meme' }),
      (response) => resolve(response)
    );
  });
};

// Get memes with filters
export const getMemes = async (params = {}) => {
  return new Promise((resolve) => {
    const { limit = 20, offset = 0, keyword } = params;
    let url = `${BASE_URL}/admin/memes?limit=${limit}&offset=${offset}`;
    
    if (keyword) url += `&keyword=${keyword}`;

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeader(
      'GET',
      url,
      null,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to fetch memes' }),
      (response) => resolve(response)
    );
  });
};

// Update a meme
export const updateMeme = async (memeId, memeData) => {
  return new Promise((resolve) => {
    const formData = new FormData();
    
    if (memeData.name) formData.append('name', memeData.name);
    if (memeData.kind) formData.append('kind', memeData.kind);
    if (memeData.category) formData.append('category', memeData.category);
    if (memeData.context) formData.append('context', memeData.context);
    if (memeData.emotion) formData.append('emotion', memeData.emotion);
    if (memeData.keywords) formData.append('keywords', JSON.stringify(memeData.keywords));
    if (memeData.image) formData.append('image', memeData.image);

    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    handleDynamicRequestHeaderMulter(
      'PUT',
      `${BASE_URL}/admin/memes/${memeId}`,
      formData,
      token,
      () => resolve({ statusCode: "50000", message: 'Failed to update meme' }),
      (response) => resolve(response)
    );
  });
};

// Delete a meme
export const deleteMeme = async (memeId) => {
  return new Promise((resolve) => {
    const sessionToken = sessionStorage.getItem("sessionToken");
    const token = sessionToken ? `Bearer ${sessionToken}` : 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJhcGkuZGV2Lnh5ei5jb20iLCJhdWQiOiJ4eXouY29tIiwic3ViIjoiMTJiNTBhNDgtNWU5ZS00MzNmLTgyNmMtMTJhNmQ3MmM5N2NkIiwiaWF0IjoxNzExNDU2OTEzLCJleHAiOjE3NDI1NjA5MTMsInBybSI6IjMwZDQyNzg2ZGMyNTU3MDBkZDkzNzViMWQ4ZDYwN2E2MzBhYzViMzJhNWU1MjUxODQ2ZDQyNzE1YjBlN2Y3YTllZjczZjAzZDk1MzI3OGQ5NTdjOTVmOGE2YTVkZjk1MTM3MDc4ZTY4ODNlNTU3MjUzODczZjViYjNjMDZiNzZmIn0.msUlenclhnnuqwdU9R5HL32rYnUVmdyITkPlzSWDcio';

    // Custom DELETE request without body
    fetch(`${BASE_URL}/admin/memes/${memeId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': token
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data) {
        resolve(data);
      } else {
        resolve({ statusCode: "50000", message: 'Failed to delete meme' });
      }
    })
    .catch(error => {
      console.error('API Error:', error);
      resolve({ statusCode: "50000", message: 'Failed to delete meme' });
    });
  });
};

